import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { fetchAuthSession } from '@aws-amplify/auth';

const EchoMailContext = createContext();

export function EchoMailProvider({ children }) {
  const [domainInfo, setDomainInfo] = useState(null);
  const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  const getAuthHeaders = async () => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      return token ? { Authorization: `Bearer ${token}` } : {};
    } catch {
      return {};
    }
  };

  const reload = async () => {
    try {
      const headers = await getAuthHeaders();
      const { data } = await axios.get(`${apiBase}/echomail/domain`, { headers });
      setDomainInfo(data.domain);
    } catch {
      setDomainInfo(null);
    }
  };

  useEffect(() => {
    reload();
  }, []);

  return (
    <EchoMailContext.Provider value={{ domainInfo, reload, getAuthHeaders }}>
      {children}
    </EchoMailContext.Provider>
  );
}

export const useEchoMail = () => useContext(EchoMailContext); 